// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2039":"329a355973880d27","2255":"96f183c6c5696589","5380":"d0891ccb0b1820d8","6951":"787dcde093812eb6"}[chunkId] + ".css";
};